@if (item) {
    <div class="flex-column">
        <div class="flex widget-header align-items-center font-semibold">
            <label
                class="flex-1 drag-handler div-ellipsis"
            >
                {{ headerLabel || (prefix + item['name'] | translate) }}
            </label>
            @if (headerActionsTemplate() || item.hasEdit || item.hasOpen || item.hasSettings || item.hasAdd) {
                <div
                    class="header-icons flex align-items-center gap-small"
                >
                    @if (headerActionsTemplate()) {
                        <ng-container [ngTemplateOutlet]="headerActionsTemplate()"></ng-container>
                    }
                    @if (item.hasEdit && canEdit() && edit.observed) {
                        <app-button icon="pi-pencil" size="small" [text]="true"
                            (clickEvent)="edit.emit()"></app-button>
                    }
                    @if (item.hasOpen && canEdit() && opened.observed) {
                        <app-button icon="pi-folder-open" size="small" [text]="true"
                            (clickEvent)="opened.emit()"></app-button>
                    }
                    @if (item.hasSettings) {
                        <i class="pi pi-ellipsis-v"></i>
                    }
                    @if (item.hasAdd && canEdit() && added.observed) {
                        <app-button icon="pi-plus" size="small" (clickEvent)="added.emit()"></app-button>
                    }
                </div>
            }
        </div>
        <div class="gridster-item-content flex-1">
            @if (!emptyState) {
                <ng-container *ngTemplateOutlet="widgetContentTemplate"></ng-container>
            } @else {
                <ng-container [ngTemplateOutlet]="widgetEmptyStateTemplate || defaultWidgetEmptyStateTemplate">
                </ng-container>
            }
        </div>
    </div>
}


<ng-template #defaultWidgetEmptyStateTemplate>
    <app-empty-state></app-empty-state>
</ng-template>
